var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errorpage"},[_c('h2',[_vm._v(_vm._s(_vm.$t('mainErrorMsg')))]),_c('h4',[_vm._v(_vm._s(_vm.errorMessage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }